export type UserRole = "ADMIN" | "READER";

export interface IUserContext {
  user_id: number;
  user_name: string;
  password: string;
  token: string;
  language: string;
  role: UserRole;
}

export type UserContextType = {
  currentUser: IUserContext;
  saveCurrentUser: (userContext: IUserContext) => void;
};

export const DefaultUserContextType: UserContextType = {
  currentUser: {
    user_id: -1,
    user_name: "",
    password: "",
    token: "",
    language: "es",
    role: "READER"
  },
  saveCurrentUser: (_: IUserContext) => {}
};
